<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">Ticket By User</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text v-if="isLoading">
      <v-progress-linear size="70" color="green" width="7" indeterminate="indeterminate">
      </v-progress-linear>
    </v-card-text>
    <v-list class="list-350" v-if="!isLoading">
      <template v-for="(row, index) in ticketByUser">
        <v-list-tile :key="row.id" avatar="avatar" ripple="ripple" @click="openTicketList(row)">
          <v-list-tile-avatar>
            <img class="br-50" v-if="row.imageUrl" :src="row.imageUrl" alt="User" />
            <img class="br-50" v-else src="../../../assets/images/user.jpeg" alt="User" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ row.fullName }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <span class="subheading">{{ row.userTickets.length }}</span>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="index + 1 < ticketByUser.length" :key="index"> </v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import taskService from "../service.js";
export default {
  data() {
    return {
      ticketByUser: [],
      isLoading: true
    };
  },
  methods: {
    openTicketList(data) {
      this.$router.push({ name: "ticket-list", params: { user: data } });
    },
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    getAllTicketbyUser() {
      taskService.getAllTicketbyUser().then(result => {
        this.ticketByUser = result.data;
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.getAllTicketbyUser();
  }
};
</script>
